'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { beforeSend } from './init-configuration/before-send';

interface Props {
  applicationId: string;
  clientToken: string;
  service: string;
}

const env = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME;
const version = process.env.NEXT_PUBLIC_GIT_SHA;
// 10% prod, 100% stage
const sessionSampleRate = env === 'prod' ? 10 : 100;

// Use a module-scoped flag to avoid reinitialization
let isDatadogInitialized = false;

export default function DatadogInit({
  applicationId,
  clientToken,
  service,
}: Props) {
  useEffect(() => {
    if (isDatadogInitialized) return;

    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.com',
      service,
      env,
      version,
      sessionSampleRate,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend,
    });

    isDatadogInitialized = true;
  }, [applicationId, clientToken, service]);

  return null;
}
